export default {
  loggedIn() {
  },
  navigate(to) {
    const accountType = to.params.accountType

    if (accountType) {
      this.$store.dispatch('resources/fetchAll', accountType);
    }

  }
}
